"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHLQATasksColumnFilterConfig = void 0;
const react_1 = require("react");
const ui_components_1 = require("@groupby/ui-components");
const constants_1 = require("./constants");
const use_hlqa_tasks_column_filter_config_utils_1 = require("./use-hlqa-tasks-column-filter-config.utils");
const client_1 = require("../../client");
const components_1 = require("../../components");
const attributes_1 = require("../../../../client/attributes");
const client_constants_1 = require("../../../../client/client.constants");
const product_tree_nodes_1 = require("../../../../client/product-tree-nodes");
const table_filter_1 = require("../../../../common/table-filter");
const MIN_SEARCH_QUERY_LENGTH = 3;
const toTerminalNodeOption = (title) => ({ label: title, value: title });
const toStrategyAttributeOption = (label) => ({ label, value: label });
const useHLQATasksColumnFilterConfig = ({ productTreeId, productTreeNodeId, statusFilterOptions, priorityFilterOptions, matchOptionsTranslate, loadCollaboratorOptions, }) => {
    var _a, _b;
    const getDateColumnFilterSortConfig = (0, table_filter_1.useDateColumnFilterSortConfig)();
    const { loadL1NodeOptions } = (0, client_1.useGetL1Nodes)({ productTreeNodeId });
    const { getAllProductTreeNodes, data: terminalNodes, pagination: terminalNodesPagination, search: terminalNodesSearch, } = (0, product_tree_nodes_1.useLazyProductTreeNodes)({
        productTreeId,
        filter: { terminalNodesOnly: true },
        pageSize: client_constants_1.DEFAULT_FILTER_PAGE_SIZE,
    });
    const { getStrategyAttributes, data: strategyAttributes, pagination: strategyAttributesPagination, search: strategyAttributesSearch, } = (0, attributes_1.useLazyGetStrategyAttributes)({
        productTreeNodeId,
        pageSize: client_constants_1.DEFAULT_FILTER_PAGE_SIZE,
    });
    const terminalNodeOptions = (0, react_1.useMemo)(() => terminalNodes.map((node) => toTerminalNodeOption(node.title)), [terminalNodes]);
    const strategyAttributeOptions = (0, react_1.useMemo)(() => { var _a; return (_a = strategyAttributes === null || strategyAttributes === void 0 ? void 0 : strategyAttributes.map(({ node }) => toStrategyAttributeOption(node.label))) !== null && _a !== void 0 ? _a : []; }, [strategyAttributes]);
    const visibleTerminalNodeOptions = (0, react_1.useMemo)(() => (terminalNodesSearch.isSearching ? [] : terminalNodeOptions), [terminalNodesSearch.isSearching, terminalNodeOptions]);
    const visibleStrategyAttributeOptions = (0, react_1.useMemo)(() => (strategyAttributesSearch.isSearching ? [] : strategyAttributeOptions), [strategyAttributesSearch.isSearching, strategyAttributeOptions]);
    const searchTerminalNodes = (0, react_1.useCallback)((query) => {
        const normalizedQuery = query.trim();
        if (normalizedQuery.length > 0 && normalizedQuery.length < MIN_SEARCH_QUERY_LENGTH) {
            return;
        }
        void getAllProductTreeNodes({
            variables: {
                productTreeId,
                filter: (0, use_hlqa_tasks_column_filter_config_utils_1.buildTerminalNodeOptionsFilter)(normalizedQuery),
                first: client_constants_1.DEFAULT_FILTER_PAGE_SIZE,
                after: null,
                search: undefined,
            },
        });
    }, [getAllProductTreeNodes, productTreeId]);
    const searchStrategyAttributes = (0, react_1.useCallback)((query) => {
        const normalizedQuery = query.trim();
        if (normalizedQuery.length > 0 && normalizedQuery.length < MIN_SEARCH_QUERY_LENGTH) {
            return;
        }
        strategyAttributesSearch.onSearch(normalizedQuery);
    }, [strategyAttributesSearch]);
    const loadTerminalNodeOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        if (!productTreeId) {
            return [];
        }
        const response = yield getAllProductTreeNodes({
            variables: {
                productTreeId,
                filter: (0, use_hlqa_tasks_column_filter_config_utils_1.buildTerminalNodeOptionsFilter)(),
                first: client_constants_1.DEFAULT_FILTER_PAGE_SIZE,
                after: null,
                search: undefined,
            },
        });
        return (_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.productTreeNodes) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.map(({ node }) => toTerminalNodeOption(node.title))) !== null && _d !== void 0 ? _d : [];
    }), [getAllProductTreeNodes, productTreeId]);
    const loadStrategyAttributeOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        if (!productTreeNodeId) {
            return [];
        }
        const response = yield getStrategyAttributes({
            variables: {
                productTreeNodeId,
                first: client_constants_1.DEFAULT_FILTER_PAGE_SIZE,
                after: null,
                before: null,
                last: null,
                filter: undefined,
            },
        });
        return (_e = (_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.productTreeNode) === null || _b === void 0 ? void 0 : _b.labelValidation) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.map(({ node }) => toStrategyAttributeOption(node.label))) !== null && _e !== void 0 ? _e : [];
    }), [getStrategyAttributes, productTreeNodeId]);
    const loadMoreTerminalNodeOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (terminalNodesPagination.isLoadingMore
            || terminalNodesSearch.isSearching
            || !terminalNodesPagination.hasNextPage) {
            return;
        }
        yield terminalNodesPagination.onNextPage();
    }), [terminalNodesPagination, terminalNodesSearch.isSearching]);
    const loadMoreStrategyAttributeOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (strategyAttributesPagination.isLoadingMore
            || strategyAttributesSearch.isSearching
            || !strategyAttributesPagination.hasNextPage) {
            return;
        }
        yield strategyAttributesPagination.onNextPage();
    }), [strategyAttributesPagination, strategyAttributesSearch.isSearching]);
    const moreTerminalNodesLoading = terminalNodesPagination.isLoadingMore;
    const moreStrategyAttributesLoading = strategyAttributesPagination.isLoadingMore;
    const hasNextTerminalNodePage = (_a = terminalNodesPagination.hasNextPage) !== null && _a !== void 0 ? _a : false;
    const hasNextStrategyAttributePage = (_b = strategyAttributesPagination.hasNextPage) !== null && _b !== void 0 ? _b : false;
    const listOperatorLabelMap = (0, react_1.useMemo)(() => (0, use_hlqa_tasks_column_filter_config_utils_1.buildListOperatorLabelMap)(matchOptionsTranslate), [matchOptionsTranslate]);
    // TODO: The filter config logic is getting quite complex, consider splitting it into separate hooks
    // eslint-disable-next-line complexity
    const getColumnFilterConfig = (0, react_1.useCallback)((columnId) => {
        switch (columnId) {
            case constants_1.HLQATasksColumns.Status:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: false,
                            options: statusFilterOptions,
                        },
                    }),
                };
            case constants_1.HLQATasksColumns.ReviewedBy:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: true,
                            loadOptions: loadCollaboratorOptions,
                        },
                    }),
                };
            case constants_1.HLQATasksColumns.Priority:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: false,
                            options: priorityFilterOptions,
                        },
                    }),
                };
            case constants_1.HLQATasksColumns.L1NodeTitle:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: true,
                            loadOptions: loadL1NodeOptions,
                        },
                    }),
                };
            case constants_1.HLQATasksColumns.TerminalNode:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: true,
                            options: visibleTerminalNodeOptions,
                            loadOptions: loadTerminalNodeOptions,
                            loadMoreOptions: loadMoreTerminalNodeOptions,
                            moreItemsLoading: moreTerminalNodesLoading,
                            hasNextPage: hasNextTerminalNodePage,
                            onSearch: searchTerminalNodes,
                            searchDebounceMs: 300,
                            virtualizationThreshold: 50,
                        },
                    }),
                };
            case constants_1.HLQATasksColumns.Attribute:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: true,
                            options: visibleStrategyAttributeOptions,
                            loadOptions: loadStrategyAttributeOptions,
                            loadMoreOptions: loadMoreStrategyAttributeOptions,
                            moreItemsLoading: moreStrategyAttributesLoading,
                            hasNextPage: hasNextStrategyAttributePage,
                            onSearch: searchStrategyAttributes,
                            searchDebounceMs: 300,
                            virtualizationThreshold: 50,
                        },
                    }),
                };
            case constants_1.HLQATasksColumns.Task:
            case constants_1.HLQATasksColumns.EscalationReason:
                return {
                    filterOperators: (0, ui_components_1.createTextFilterOperators)({
                        operatorLabelMap: matchOptionsTranslate,
                        allowedOperators: Object.keys(matchOptionsTranslate),
                        inputProps: {},
                    }),
                };
            case constants_1.HLQATasksColumns.TotalProducts:
            case constants_1.HLQATasksColumns.ProductsReviewed:
            case constants_1.HLQATasksColumns.PercentReviewed:
            case constants_1.HLQATasksColumns.TaskCount:
            case constants_1.HLQATasksColumns.NotApplicable:
            case constants_1.HLQATasksColumns.Unknown:
            case constants_1.HLQATasksColumns.CorrectionsCount:
            case constants_1.HLQATasksColumns.CorrectionsPercentage:
            case constants_1.HLQATasksColumns.TotalCorrectionsPercentage:
                return {
                    filterOperators: (0, ui_components_1.createNumberFilterOperators)({ inputProps: {} }),
                };
            case constants_1.HLQATasksColumns.AssignedTo:
                return {
                    filterOperators: (0, ui_components_1.createListFilterOperators)({
                        allowedOperators: use_hlqa_tasks_column_filter_config_utils_1.HLQA_TASKS_LIST_FILTER_OPERATORS,
                        operatorLabelMap: listOperatorLabelMap,
                        inputProps: {
                            groupActions: true,
                            searchable: true,
                            loadOptions: loadCollaboratorOptions,
                        },
                        InputComponent: components_1.CollaboratorFilterControl,
                    }),
                };
            case constants_1.HLQATasksColumns.InstructionsUpdatedAt:
            case constants_1.HLQATasksColumns.LastReviewedAt:
                return getDateColumnFilterSortConfig({ id: columnId });
            default:
                return {};
        }
    }, [
        getDateColumnFilterSortConfig,
        hasNextStrategyAttributePage,
        hasNextTerminalNodePage,
        loadCollaboratorOptions,
        loadL1NodeOptions,
        loadMoreStrategyAttributeOptions,
        loadMoreTerminalNodeOptions,
        loadStrategyAttributeOptions,
        loadTerminalNodeOptions,
        listOperatorLabelMap,
        matchOptionsTranslate,
        moreStrategyAttributesLoading,
        moreTerminalNodesLoading,
        priorityFilterOptions,
        searchStrategyAttributes,
        searchTerminalNodes,
        statusFilterOptions,
        visibleStrategyAttributeOptions,
        visibleTerminalNodeOptions,
    ]);
    return getColumnFilterConfig;
};
exports.useHLQATasksColumnFilterConfig = useHLQATasksColumnFilterConfig;
